import { motion } from 'motion/react';

const pulseAnimation = {
  opacity: [0.3, 0.6, 0.3],
};

const pulseTransition = {
  duration: 1.5,
  repeat: Infinity,
  ease: 'easeInOut' as const,
};

export function InterstitialSkeleton() {
  return (
    <div className="h-screen w-full flex flex-col items-center justify-center bg-black">
      <motion.div
        className="flex flex-col items-center gap-6 w-full max-w-md px-8"
        animate={pulseAnimation}
        transition={pulseTransition}
      >
        <div className="w-32 h-32 bg-gray-700 rounded-full" />
        <div className="w-3/4 h-8 bg-gray-700 rounded" />
        <div className="w-1/2 h-6 bg-gray-700 rounded" />
      </motion.div>
    </div>
  );
}
